// i18nOwl-ignore [app-cohort.medias.video.title]
import MediaContentCohortVideo from '@cohort/components-xps/components/contents/apps/cohort/video/MediaContentCohortVideo';
import type {ContentMedia} from '@cohort/merchants/apps';
import CohortVideoMediaConfigComponent from '@cohort/merchants/apps/cohort/medias/video/ConfigComponent';
import CohortVideoVisualPreview from '@cohort/merchants/apps/cohort/medias/video/VisualPreview';
import type {CohortVideoMediaStruct} from '@cohort/shared/apps/cohort/medias/video';
import {CohortVideoMediaSpec} from '@cohort/shared/apps/cohort/medias/video';
import {Video} from '@phosphor-icons/react';

export const CohortMediaVideo: ContentMedia<CohortVideoMediaStruct> = {
  spec: CohortVideoMediaSpec,
  configComponent: CohortVideoMediaConfigComponent,
  getTitle: t => t('medias.video.title', {ns: 'app-cohort'}),
  mediaContent: MediaContentCohortVideo,
  icon: ({size, textColor}) => <Video size={size} className={textColor} />,
  visualPreview: CohortVideoVisualPreview,
};
